import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'

const contents_insurance_choice = (params: StepConfigParams) =>
  ({
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_contentsNxt:steps.contents_insurance_choice.title',
        },
      },
      {
        type: 'subtitle',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_contentsNxt:steps.contents_insurance_choice.subtitle',
        },
      },
      {
        type: 'yesNo',
        shouldTrackValues: true,
        name: `product_keys.${params.productKey}`,
      },
    ],
    onPrepare: {
      type: 'simpleHook',
      callback: () => {
        return {
          formValues: {
            [`product_keys.${params.productKey}`]: '',
          },
        }
      },
    },
    nextStep: '',
    subFlow: params.subFlow,
  }) as const satisfies AnyStepConfiguration

export default contents_insurance_choice
